module.exports = __webpack_public_path__ + "img/crop-icon.b1ba0cf1.svg";